<template>
    <div class="products-steel">
        <div class="row" v-if="!subPage">
            <div
                v-for="card in cardsProducts"
                :key="card.title"
                class="col-default-4 col-v-tablet-12 col-mobile-12">
                <z-card
                    theme="background"
                    :image="card.image"
                    full-height
                >
                    <template v-slot:title>
                        {{ card.title }}
                    </template>
                    <template v-slot:bottom>
                        <z-button
                            kind="text"
                            class="z-button--arrow"
                            tag="a"
                            :href="card.url"
                        >
                            {{ text.more }}
                            <template v-slot:right>
                                <z-icon
                                    name="btn-arrow"
                                    width="16"
                                    height="16"
                                    color="#E32112"
                                ></z-icon>
                            </template>
                        </z-button>
                    </template>
                </z-card>
            </div>
        </div>
        <!-- <div class="row" v-if="initial.type !== 'industry'">
            <div class="col-default-4 col-v-tablet-12 col-mobile-12">
                <z-card
                    theme="background"
                    image="/images/products/wholesale.jpg"
                    full-height
                    :link="`/${lang}/contacts/`"
                >
                    <template v-slot:title>
                        {{ text.buyInBulk }}
                    </template>
                    <template v-slot:content>
                        {{ text.contacts }}
                    </template>
                    <template v-slot:bottom>
                        <z-button
                            kind="text"
                            class="z-button--arrow"
                        >
                            {{ text.more }}
                            <template v-slot:right>
                                <z-icon
                                    name="btn-arrow"
                                    width="16"
                                    height="16"
                                    color="#E32112"
                                ></z-icon>
                            </template>
                        </z-button>
                    </template>
                </z-card>
            </div>
            <div class="col-default-4 col-v-tablet-12 col-mobile-12">
                <z-card
                    theme="background"
                    image="/images/products/certificates-check.jpg"
                    full-height
                    :link="`/${lang}/clients/claims/`"
                >
                    <template v-slot:title>
                        {{ text.claims }}
                    </template>
                    <template v-slot:bottom>
                        <z-button
                            kind="text"
                            class="z-button--arrow"
                        >
                            {{ text.more }}
                            <template v-slot:right>
                                <z-icon
                                    name="btn-arrow"
                                    width="16"
                                    height="16"
                                    color="#E32112"
                                ></z-icon>
                            </template>
                        </z-button>
                    </template>
                </z-card>
            </div>
            <div class="col-default-4 col-v-tablet-12 col-mobile-12">
                <z-card
                    full-height
                >
                    <template v-slot:title>
                        {{ text.feedback }}
                    </template>
                    <template v-slot:content>
                        <div v-html="text.feedbackText"></div>
                    </template>
                    <template v-slot:bottom>
                        <z-button tag="a" href="mailto:sales@tcmstrade.ru" kind="text">
                            {{ text.contactUs }}
                            <template v-slot:right>
                                <z-icon name="email" width="24" height="24"></z-icon>
                            </template>
                        </z-button>
                    </template>
                </z-card>
            </div>
        </div> -->
        <filters
            :data="filters"
            :initial="initial"
            @search="onChange"
        />
        <results
            :data="list"
            :nav="nav"
            v-if="list.length"
        />
        <z-preloader v-if="loading" />
        <z-not-found
            :text="text.notFoundText"
            :title="text.notFoundTitle"
            v-if="!list.length && !loading && isSearched"
        />
        <z-pagination
            show-next
            show-prev
            @change-page="onPageChange"
            v-if="list.length && !loading"
            :data="{
                pageRange: 1,
                totalItems: nav.count,
                totalPages: nav.total,
                currentPage: nav.current
            }"
        />
    </div>
</template>

<script>
import Results from './Results.vue'
import Filters from './Filters.vue'
import { localize } from '@/utils/i18n'
import { debounce } from 'throttle-debounce'
import { queryString } from '@/utils/queryString'
import getProducts from '@/api/products'

export default {
    name: 'products',
    components: {
        Results,
        Filters
    },
    props: {
        initial: {
            type: Object,
            default: () => ({
                text: '',
                type: ''
            })
        },
        hidePrices: {
            type: Boolean,
            default: false
        },
        hideCertificates: {
            type: Boolean,
            default: false
        },
        subPage: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            page: 1,
            loading: false,
            isSearched: false,
            params: this.initial,
            data: this.$root.app.components['products'],
            filters: {},
            nav: {},
            list: [],
            lang: this.$root.lang,
            text: {
                feedback: localize({
                    ru: 'Обратная связь',
                    en: 'Feedback'
                }),
                feedbackText: localize({
                    ru: 'Если у&nbsp;вас есть вопросы, вы&nbsp;можете задать их&nbsp;нашим специалистам, написав нам на&nbsp;почту.',
                    en: 'If&nbsp;you have any questions, please contact our specialists by&nbsp;e-mail.'
                }),
                contactUs: localize({
                    ru: 'Написать',
                    en: 'Contact us'
                }),
                showMore: localize({
                    ru: 'Показать еще',
                    en: 'Show more'
                }),
                notFoundTitle: localize({
                    ru: 'Ничего не&nbsp;найдено',
                    en: 'No&nbsp;results found'
                }),
                notFoundText: localize({
                    ru: 'По&nbsp;Вашему запросу ничего не&nbsp;нашлось.',
                    en: 'Sorry, no&nbsp;matches were found for your request. Try changing your search terms.'
                }),
                more: localize({
                    ru: 'Подробнее',
                    en: 'More'
                }),
                claims: localize({
                    ru: 'Претензионная работа',
                    en: 'Claims'
                }),
                download: localize({
                    ru: 'Скачать',
                    en: 'Download'
                }),
                buyInBulk: localize({
                    ru: 'Купить оптом',
                    en: 'Buy in bulk'
                }),
                checkingProductCertificates: localize({
                    ru: 'Проверка сертификатов на&nbsp;продукцию',
                    en: 'Checking product certificates'
                }),
                priceLists: localize({
                    ru: 'Прайс-листы',
                    en: 'Price lists'
                }),
                contacts: localize({
                    ru: 'Контакты для покупателей',
                    en: 'Customers contacts'
                })
            },
            cardsProducts: [
                {
                    url: `/${this.$root.lang}/products/construction/`,
                    title: localize({
                        ru: 'Продукция строительного назначения',
                        en: 'Construction products'
                    }),
                    image: '/images/products/construction.jpg'
                },
                {
                    url: `/${this.$root.lang}/products/industry/`,
                    title: localize({
                        ru: 'Продукция промышленного назначения',
                        en: 'Industrial products'
                    }),
                    image: '/images/products/industry.jpg'
                },
                {
                    url: `/${this.$root.lang}/contacts/#accordion-vanadium-products-sales`,
                    title: localize({
                        ru: 'Ванадиевая продукция',
                        en: 'Vanadium products'
                    }),
                    image: '/images/products/vanadium.jpg'
                }
            ]
        }
    },
    created () {
        if (this.data) {
            this.nav = this.data.nav
            if (this.subPage) {
                this.list = this.data.items
            }
            this.filters = this.data.filters
        } else {
            this.send(this.params)
        }
    },
    methods: {
        onChange (data) {
            this.page = 1
            this.params = { ...data, page: this.page }
            this.send(this.clearEmptyParams(this.params))
        },
        onPageChange (page) {
            this.page = page
            this.params = { ...this.params, page: this.page }
            this.send(this.clearEmptyParams(this.params))
        },
        send: debounce(1000, function (params) {
            this.loading = true
            this.isSearched = true

            if (this.page === 1) this.list = []

            getProducts(params).then(res => {
                this.updateNav(res)
                this.updateList(res)
                this.updateFilters(res)

                queryString(params)

                this.loading = false
            })
        }),
        updateNav (res) {
            if (res.hasOwnProperty('nav')) {
                this.nav.current = res.nav.current
                this.nav.total = res.nav.total
                this.nav.count = res.nav.count
            }
        },
        updateList (res) {
            if (res.hasOwnProperty('items')) {
                this.list = res.items
            }
        },
        updateFilters (res) {
            if (res.hasOwnProperty('filters')) {
                if (Object.keys(res.filters).length) this.filters = res.filters
            }
        },
        clearEmptyParams () {
            let params = Object.assign({}, this.params)

            Object.keys(params).forEach(function (key, index) {
                if (Array.isArray(params[key])) {
                    if (!(params[key].filter(val => { return val !== null && val !== undefined && val !== '' }).length)) delete params[key]
                } else if (!params[key]) {
                    delete params[key]
                }
            })

            return params
        }
    }
}
</script>

<style lang="scss">
.products-steel {
    .z-card--theme-background {
        .z-card__helper-image {
            &:before {
                content: '';
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: $token-colors-black;
                opacity: .5;
                position: absolute;
            }
        }
    }
}
</style>
